<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center">
      <h1>SEO Tools</h1>
      <div class="div-page-description"><h5>Optimize your website effortlessly with our SEO tools and improve search engine visibility for better rankings.</h5></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="card text-center" >
            <div class="card-body">
              <h5 class="card-title">Title Checker</h5>
              <p class="card-text">Check your page's title length</p><br />
              <a [routerLink]="['/website-title-checker']" class="btn btn-primary">Check</a>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card text-center">
            <div class="card-body">
              <h5 class="card-title">Meta Description Checker</h5>
              <p class="card-text">Check your page's meta description length</p><br />
              <a [routerLink]="['/meta-description-checker']" class="btn btn-primary">Check</a>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card text-center">
            <div class="card-body">
              <h5 class="card-title">Open Graph Checker</h5>
              <p class="card-text">Check your page's open graph and twitter card meta tags</p>
              <a [routerLink]="['/open-graph-checker']" class="btn btn-primary">Check</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
